import { IProductCardData } from 'components/ProductCard';

export const sortProducts = (products: IProductCardData[], productsOrder: string[]) => {
  const urlIndexMap = productsOrder.reduce((map, url, idx) => {
    map[url] = idx;

    return map;
  }, {});

  const maxIndex = productsOrder.length;

  products.sort((a, b) => {
    const indexA = urlIndexMap[a.link] !== undefined ? urlIndexMap[a.link] : maxIndex;
    const indexB = urlIndexMap[b.link] !== undefined ? urlIndexMap[b.link] : maxIndex;

    return indexA - indexB;
  });
};
